const Loading = ({ text }: { text?: string }) => {
  return (
    <div className="flex min-h-[400px] items-center justify-center">
      <div className="text-center">
        <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-solid border-brand-500 border-t-transparent"></div>
        <p className="text-gray-600 dark:text-gray-400">
          {text ?? "Loading..."}
        </p>
      </div>
    </div>
  );
};

export default Loading;
